"use strict";

exports.__esModule = true;
exports.default = number;

function number(value) {
  return /^\d+$/.test(value);
}


//////////////////
// WEBPACK FOOTER
// ./~/vant/lib/utils/validate/number.js
// module id = 649
// module chunks = 1